<div [ngClass]="cssClass">
<router-outlet></router-outlet>
</div>